import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  appID: null,
  clseList: [],
  general: {
    init: 0,
    initErr: [],
    menu: {}
  },
  statistics: {
    init: 0,
    initErr: [],
    menu: {}
  },
  coverage: {
    init: 0,
    initErr: [],
    menu: {}
  },
  benefit: {
    init: 0,
    initErr: [],
    menu: {}
  },
  uom: {
    init: 0,
    initErr: [],
    menu: {}
  },
  stdRisk: {
    init: 0,
    initErr: [],
    menu: {},
    text: {
      init: 0,
      initErr: [],
      menu: {}
    },
    itemText: {
      init: 0,
      initErr: [],
      menu: {}
    }
  },
  busCls: {
    init: 0,
    initErr: [],
    menu: {},
    tariffList: [],
    coverList: [],
    vehGrpList: [],
    busClsMenu: {
      init: 0,
      initErr: [],
      busClsTarfList: [],
      busClsCoverList: [],
      sideMenuTitle: '',
      menu: {}
    },
    tariff: {
      init: 0,
      initErr: [],
      menu: {}
    },
    cover: {
      init: 0,
      initErr: [],
      menu: {}
    }
  },
  tariff: {
    init: 0,
    initErr: [],
    menu: {},
    benefit: {
      init: 0,
      initErr: [],
      menu: []
    },
    factor: {
      init: 0,
      initErr: [],
      menu: {}
    },
    tarfBen: {
      init: 0,
      initErr: [],
      menu: {}
    },
    tarfRate: {
      init: 0,
      initErr: [],
      menu: {}
    },
    tarfFact: {
      init: 0,
      initErr: [],
      menu: {}
    }
  },
  scheme: {
    init: 0,
    initErr: [],
    menu: {},
    schemeMenu: {
      init: 0,
      initErr: [],
      menu: {},
      sideMenuTitle: ''
    },
    pkgPlanMenu: {
      init: 0,
      initErr: [],
      menu: {},
      pkgPlanTitle: ''
    },
    pkgRiskMenu: {
      init: 0,
      initErr: [],
      menu: {},
      pkgRiskTitle: ''
    },
    pkgRiskItemMenu: {
      init: 0,
      initErr: [],
      menu: {},
      pkgRiskItemTitle: ''
    },
    stdRiskTxtMenu: {
      init: 0,
      initErr: [],
      menu: {},
      stdRiskTxt: null,
      title: ''
    },
    stdItemTxtMenu: {
      init: 0,
      initErr: [],
      menu: {},
      title: ''
    },
    pkgTarfBenMenu: {
      init: 0,
      initErr: [],
      menu: {},
      title: ''
    },
    pkgTarfFactMenu: {
      init: 0,
      initErr: [],
      menu: {},
      factor: {},
      title: ''
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
